import { render, staticRenderFns } from "./SideCloud.vue?vue&type=template&id=445b9e2e"
var script = {}
import style0 from "./SideCloud.vue?vue&type=style&index=0&id=445b9e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports